export default __webpack_public_path__ + "b8a9ce5.png";